<template>
  <ul>
    <li>
      <template>
        <a class="impersonate-btn" lass="text-title" @click.prevent="toggleForm">
          <span>
            <i class="xb-icon-switch" />
          </span>
          <span>Impersonation</span>
        </a>
      </template>
      <transition name="slide-fade">
        <div v-if="isFormShow" class="impersonate-form">
          <form class="xb-form" @submit.prevent="validateBeforeSubmit">
            <b-field
              custom-class="required"
              class="xb-input"
              label="NRIC/FIN"
              :type="{ 'is-danger': errors.has('NRIC') }"
              :message="errors.first('NRIC')"
            >
              <b-input
                v-model="nric"
                v-validate="'required|nric_fin'"
                name="NRIC"
                placeholder="NRIC/FIN"
              />
            </b-field>

            <template v-if="isEA">
              <b-field
                custom-class="required"
                class="xb-input"
                :type="{ 'is-danger': errors.has('UEN') }"
                :message="errors.first('UEN')"
                label="UEN"
              >
                <b-input v-model="uen" v-validate="'required|uen'" name="UEN" placeholder="UEN" />
              </b-field>
            </template>

            <div class="buttons">
              <button class="xb-button button is-secondary" type="submit">Impersonate</button>
            </div>
          </form>
        </div>
      </transition>
    </li>
  </ul>
</template>

<script>
export default {
  name: "Impersonation",
  props: {
    isEA: {
      type: Boolean,
      required: false,
      default: true
    },
    impersonate: {
      type: Function,
      required: false,
      default: () => false
    }
  },
  data() {
    return {
      isFormShow: false,
      nric: null,
      uen: null
    };
  },
  methods: {
    toggleForm() {
      this.isFormShow = !this.isFormShow;
    },
    async validateBeforeSubmit() {
      const result = await this.$validator.validateAll();
      if (result) {
        this.$emit("impersonate", { nric: this.nric, uen: this.uen });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.impersonate-form {
  padding: 10px 20px;
  margin-bottom: 10px;
  border-top: 1px solid lightgray;
}

.impersonate-btn {
  span {
    i {
      margin-right: 10px;
    }
  }
}

/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all 0.5s ease;
}
.slide-fade-leave-active {
  transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(15px);
  opacity: 0;
}
</style>

<style lang="scss">
.impersonate-form {
  .xb-input.field:not(:last-child) {
    margin-bottom: 10px;
  }

  .label:not(:last-child) {
    margin-bottom: 0;
  }

  .xb-input.field input {
    min-height: 20px;
    padding: 5px;

    &::placeholder {
      font-size: 14px;
    }
  }

  .xb-input.field label.label {
    font-size: 14px;
  }

  .xb-button.button {
    padding: 5px 10px;
  }

  .xb-input.field p.help.is-danger,
  .xb-input.field p.help.is-success {
    font-size: 12px;
    line-height: 18px;
  }
}
</style>
